export const FETCH_ONBOARDINGRESIDENTSDATA_INIT_ACTION = "FETCH_ONBOARDINGRESIDENTSDATA_INIT_ACTION";
export const FETCH_ONBOARDINGRESIDENTSDATA_SUCCESS_ACTION =
  FETCH_ONBOARDINGRESIDENTSDATA_INIT_ACTION + "_SUCCESS";
export const FETCH_ONBOARDINGRESIDENTSDATA_FAIL_ACTION =
  FETCH_ONBOARDINGRESIDENTSDATA_INIT_ACTION + "_ERROR";

  export const APPROVE_ONBOARDINGRESIDENTSDATA_INIT_ACTION = "APPROVE_ONBOARDINGRESIDENTSDATA_INIT_ACTION";
  export const APPROVE_ONBOARDINGRESIDENTSDATA_SUCCESS_ACTION =
  APPROVE_ONBOARDINGRESIDENTSDATA_INIT_ACTION + "_SUCCESS";
  export const APPROVE_ONBOARDINGRESIDENTSDATA_FAIL_ACTION =
  APPROVE_ONBOARDINGRESIDENTSDATA_INIT_ACTION + "_ERROR";